import 'src/material/global/vendor/datatables/jquery.dataTables';
import 'src/material/global/vendor/datatables/datatables.css';
import bookingService from './../../../services/booking';
import accountService from './../../../services/account';
import rentalService from './../../../services/rental';
import Vue from 'vue';
import moment from 'moment';
import mixin from '../../../mixins/mixin';
import DatePicker from 'vue2-datepicker';
import formService from './../../../services/form';

export default {
  data() {
    return {
      sortById: true,
      sortByRental: true,
      sortByGuestName: true,
      sortByCheckIn: false,
      sortByCheckOut: true,
      sortByDate: true,
      sortByNights: true,
      sortByPeople: true,
      sortByChannel: true,
      sortByStatus: true,
      loading: true,
      bookings: [],
      mode: 'grid',
      filterByName: '',
      filterByStatus: 'not_cancelled',
      bookingItem: [],
      guestItem: [],
      bookingDetails: false,
      rentalItem: [],
      channelItem: [],
      limit: 50,
      currentPage: 0,
      lastPage: '',
      totalCount: '',
      checkingFilter: '',
      language: 'en',
      filteredEmpty: false,
      rentals: [],
      groups: [],
      shortcuts: [
        {
          text: this.$t('booking.index.checkin'),
          start: moment().format('MMM DD, YYYY'),
          end: moment().add(14, 'days').format('MMM DD, YYYY'),
        },
        {
          text: this.$t('booking.index.checkout'),
          start: moment().format('MMM DD, YYYY'),
          end: moment().add(14, 'days').format('MMM DD, YYYY'),
        },
      ],
      user: {
        is_team_member: '',
        rights: {},
        currency: {},
      },
      searchStart: false,
      setTimeOut: false,
      filterCheckingFrom: '',
      filterCheckingTo: '',
      checkedRentals: {},
      checkedGroups: {},
      others: [],
      showBookingActions: false,
      showBookingPrices: false,
      orderByField: 'checking',
      orderByDirection: 'desc',
      orderByType: null,
      paymentStatus: '',
      depositStatus: '',
      membersForChecking: [],
      membersForCheckout: [],
      isFirstWatch: false,
      bookingUrl: null,
    };
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading: require('components/loading/loading.vue'),
    VExportBookings: require('components/export-bookings/export-bookings.vue'),
    DatePicker,
    VManageLocks: require('components/manage-locks/manage-locks.vue'),
    VImportBookingsFromFile: require('../../rentals/detail/modals/ImportBookingsFromFile'),
  },
  mixins: [mixin],
  async mounted() {
    const vm = this;

    mixpanel.track('web.bookings.list');
    
    Date.prototype.getWeek = function () {
      const date = new Date(this.getTime());
      date.setHours(0, 0, 0, 0);
      // Thursday in current week decides the year.
      date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
      // January 4 is always in week 1.
      const week1 = new Date(date.getFullYear(), 0, 4);
      // Adjust to Thursday in week 1 and count number of weeks from date to week1.
      return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
        - 3 + (week1.getDay() + 6) % 7) / 7);
    };

    $('.panel-overlay').click(() => {
      vm.closeDetailModal();
    });

    await vm.getAccountRights();
    await rentalService.getGroups(vm, true);

    if (this.account && this.account.id && !this.isFirstWatch) {
      const filters = await this.setExistingFilters();
      if (!filters || (filters && filters === 'not_cancelled')) {
        await this.getBookingForSorting();
      }
    }

    Vue.filter('getWeekDayFromDate', date => moment(date).format('ddd DD MMMM . YYYY'));

    this.$nextTick(() => {
      $('#bookings-table>tbody').css('width', $('.page-content').width() - 48);
      $('#bookings-table>tbody').css('height', $('.bookings-table-sizes').height());
      const w = $('#bookings-table>tbody');
      const row = $('.currentWeek');

      if (row.length) {
        $('#bookings-table,tbody').scrollTop(row.offset().top - (w.height() / 2));
      }
    });
    await vm.getOtherRentals();
    Vue.set(vm, 'sortByDate', false); // sort by checkin date by default
  },
  watch: {
    checkingFilter(newData) {
      const vm = this;
      vm.filteredEmpty = false;
      if (newData[0] && newData[1]) {
        vm.filterCheckingFrom = moment(newData[0]).format('Y-MM-DD');
        vm.filterCheckingTo = moment(newData[1]).format('Y-MM-DD');
      } else {
        vm.filterCheckingFrom = '';
        vm.filterCheckingTo = '';
      }
      vm.getBooking(true);
    },
    filterByStatus(newVal) {
      this.filteredEmpty = false;
      this.currentPage = 0;
      this.filterByStatus = newVal;
      let data = {
        status: '',
      };
      if (this.account) {
        if (localStorage.getItem(`user_${this.account.id}_booking_filter`)) {
          data = JSON.parse(localStorage.getItem(`user_${this.account.id}_booking_filter`));
        }
        data.status = newVal || this.filterByStatus;
        localStorage.setItem(`user_${this.account.id}_booking_filter`, JSON.stringify(data));
      }
      this.getBookingForSorting();
    },
    account: {
      async handler(newVal) {
        if (newVal && newVal.id && !this.isFirstWatch) {
          this.isFirstWatch = true;
          const filters = await this.setExistingFilters();
          if (!filters || (filters && filters === 'not_cancelled')) {
            await this.getBookingForSorting();
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    filterByRentals(id = null) {
      this.currentPage = 0;
      const vm = this;
      if (id != null) {
        const group = vm.groups.filter(g => g.id === id)[0];
        const groupRentals = group.rentals;
        for (let i = 0; i < groupRentals.length; i += 1) {
          Vue.set(vm.checkedRentals, groupRentals[i].id, vm.checkedGroups[id]);
        }
      }

      for (let i = 0; i < vm.groups.length; i += 1) {
        const group = vm.groups[i];
        for (let j = 0; j < group.rentals.length; j += 1) {
          const rental = group.rentals[j];
          if (!vm.checkedRentals[rental.id]) {
            Vue.set(vm.checkedGroups, group.id, false);
            break;
          }
          Vue.set(vm.checkedGroups, group.id, true);
        }
      }
      let rentalIds = [];
      for (const index in this.checkedRentals) {
        if (this.checkedRentals[index]) {
          rentalIds = [...rentalIds, parseInt(index)];
        }
      }
      this.saveCheckedRentalIds(rentalIds);
      this.getBookingForSorting();
    },
    getWeekDayFromDate(date) {
      moment.locale('fr', {
        months: this.$t('months'),
        weekdaysShort: this.$t('medWeekDays'),
        monthsShort: this.$t('shortMonths'),
      });
      return moment(date).format('ddd DD MMMM . YYYY');
    },
    async getBooking(fromFilter = false) {
      const vm = this;
      if (fromFilter) {
        vm.loading = true;
        vm.currentPage = 0;
      }
      const rentals = [];
      for (const k in vm.checkedRentals) {
        if (vm.checkedRentals[k] == true) {
          rentals.push(parseInt(k));
        }
      }
      await bookingService.get(vm, fromFilter, vm.limit, vm.currentPage, vm.filterByName,
        vm.filterCheckingFrom, vm.filterCheckingTo, vm.filterByStatus, rentals,
        JSON.stringify({ [vm.orderByField]: vm.orderByDirection }));
    },
    async getBookingForSorting() {
      let rentals = [];
      for (const k in this.checkedRentals) {
        if (this.checkedRentals[k] === true) {
          rentals.push(parseInt(k));
        }
      }
      rentals = this.getSavedRentalIds();
      this.saveCheckedRentalIds(rentals);
      await bookingService.getBookingsForSorting(this, this.limit,
        this.currentPage, encodeURIComponent(this.filterByName), this.filterByStatus, rentals,
        JSON.stringify({ [this.orderByField]: this.orderByDirection }), this.orderByType);
    },
    async getAccountRights() {
      const vm = this;
      await accountService.getAccountRights(vm);
    },
    sortBy(param, direction, type = null) {
      this.setOrderParams(param, direction, type);
      if (this.account) {
        const data = {
          param,
          direction,
          type,
          status: this.filterByStatus,
        };
        localStorage.setItem(`user_${this.account.id}_booking_filter`, JSON.stringify(data));
      }
      this.getBookingForSorting();
    },
    new_booking() {
      Vue.router.push({
        name: 'bookings.create',
      });
    },
    edit(id) {
      Vue.router.push({
        name: 'bookings.details',
        params: { id },
      });
    },
    async showDetail(booking, rental) {
      const vm = this;
      this.bookingUrl = this.getBookingUrl(booking, rental);
      vm.bookingDetails = true;
      vm.bookingItem = booking;
      vm.guestItem = booking.guest;
      vm.rentalItem = rental;
      vm.channelItem = booking.channel;
      const rights = Object.values(vm.user.rights);
      const rightExists = rights.find(item => item.parent_id === vm.bookingItem.rental.user_id);
      vm.paymentStatus = booking.payment_is_done === 1 ? 'OK' : 'KO';
      vm.depositStatus = booking.statusCode !== 14 && booking.deposit_is_done === 1 ? 'OK' : 'KO';
      vm.showBookingActions = (rightExists && rightExists.booking_actions);
      vm.showBookingPrices = (rightExists && rightExists.booking_prices);
      vm.groups.map((group) => {
        group.rentals.map((rental) => {
          if (rental.id === booking.rental_id) {
            if (rental.the_keys_locks && rental.the_keys_locks.length > 0) {
              vm.rentalItem.the_keys_locks = rental.the_keys_locks;
              booking.areLocksConnectedToBookingRental = true;
            } else {
              booking.areLocksConnectedToBookingRental = false;
            }
          }
        });
      });

      $('.panel-overlay').fadeIn();
      $('.calendar-month-view .panel').addClass('active');
      $('.calendar-month-view .panel').css({ right: '0' });
      $('.pannel_sec_second').css({ right: '-350px' });

      await bookingService.getBookingsSelectedDay(this, booking.checking, [], true);
      await bookingService.getBookingsSelectedDay(this, booking.checkout, [], true);
    },
    closeDetailModal() {
      const vm = this;
      $('.calendar-month-view .panel').removeClass('active');
      $('.panel-overlay').fadeOut();
      $('.pannel_sec_second').css({ right: '-350px' });
      vm.bookingDetails = false;
      vm.showBookingActions = false;
      vm.showBookingPrices = false;
    },
    toBooking(id, tab, isViewBooking = false) {
      this.closeDetailModal();
      if (!isViewBooking) {
        Vue.router.push({
          name: 'bookings.details.tab',
          params: { id, tab },
        });
      }
    },
    onChangeFollowUp() {
      const vm = this;
      vm.bookingItem.first_name = vm.bookingItem.guest.first_name;
      vm.bookingItem.last_name = vm.bookingItem.guest.last_name;
      vm.bookingItem.email = vm.bookingItem.guest.email;
      vm.bookingItem.phone = vm.bookingItem.guest.phone;
      bookingService.updateBooking(vm.bookingItem, this);
    },
    async prevPage() {
      if (this.currentPage <= 0) {
        return false;
      }
      if (this.currentPage > 0) this.currentPage -= 1;
      this.loading = true;
      await this.getBookingForSorting();
      this.loading = false;
    },
    async nextPage() {
      if (this.lastPage < this.limit || this.lastPage === this.totalCount) {
        return false;
      }
      this.currentPage += 1;
      this.loading = true;
      await this.getBookingForSorting();
      this.loading = false;
    },
    refreshBooking() {
      this.openModal('.sync-in-process-modal');
      bookingService.refreshBookings(this, 'bookings');
    },
    searchBookings() {
      if (this.setTimeOut) {
        clearTimeout(this.setTimeOut);
      }
      this.setTimeOut = setTimeout(() => { this.getBookingForSorting(); }, 2000);
    },
    getBookingClassName(id, code, done) {
      if (done == 1 && id == 1) {
        return 'confirmed';
      }

      if ((id == 1 && code == 12) || id === 3) {
        return 'confirmed';
      } else if (id == 0 && code == 20) {
        return 'refunded';
      } else if (id == 0) {
        return 'cancelled';
      }
      return '';
    },
    getOtherRentals() { // get rentals which are not in any groups
      const removed = [];
      const isGroups = this.groups.length > 0;
      // if there are not groups then all rentals will be in 'others' group
      if (!isGroups) {
        const group = {
          id: 0,
          name: this.$t('groups.all'),
          rentals: this.others,
        };
        Vue.set(this.groups, this.groups.length, group);
      }
      for (let i = 0; i < this.rentals.length; i++) {
        const rental = this.rentals[i];
        for (let j = 0; j < this.groups.length; j++) {
          const group = this.groups[j];
          const check = group.rentals.filter(r => r.id === rental.id);
          if (check.length > 0) {
            const check1 = this.others.filter(r => r.id === rental.id);
            if (check1.length > 0) {
              const index = this.others.indexOf(rental);
              this.others.splice(index, 1);
              break;
            }
            removed.push(rental);
          } else {
            const check2 = this.others.filter(r => r.id === rental.id);
            if (check2.length === 0 && !removed.includes(rental)) {
              this.others.push(rental);
            }
          }
        }
      }
      // add group with rentals which are not in any groups
      if (isGroups) {
        const group = {
          id: 0,
          name: this.$t('groups.others'),
          rentals: this.others,
        };
        Vue.set(this.groups, this.groups.length, group);
      }
      return this.others;
    },
    changeStatus(event, booking) {
      const data = {};
      data.id = booking.id;
      if (event === 'payment') {
        data.payment = this.paymentStatus;
      } else if (event === 'deposit') {
        data.deposit = this.depositStatus;
      }
      bookingService.changeEventStatuses(this, data, event, booking);
    },
    openImportNewRentalsModal() {
      this.$refs.airbnbImportModal.openImportNewRentalsModal();
    },
    async addOrChangeTeamMember(bookingId, memberId, type) {
      const data = {
        bookingId,
        memberId,
        type,
      };
      await bookingService.assignTeamMemberToBooking(this, data, null, type, true);
    },
    changeFormStatus(type, booking) {
      const data = {
        id: booking.id,
        welcome_form_submitted: booking.welcome_form_submitted,
        checkin_form_submitted: booking.checkin_form_submitted,
        type,
      };
      formService.changeFormStatus(this, data);
    },
    setOrderParams(param, direction, type = null, status = null) {
      this.orderByField = param;
      this.orderByDirection = direction ? 'asc' : 'desc';
      this.orderByType = type;
      this.filterByStatus = status || this.filterByStatus;
    },
    setExistingFilters() {
      if (this.account && localStorage.getItem(`user_${this.account.id}_booking_filter`)) {
        const filters = JSON.parse(localStorage.getItem(`user_${this.account.id}_booking_filter`));
        this.setOrderParams(filters.param ? filters.param : this.orderByField, filters.direction !== undefined ? filters.direction : this.orderByDirection,
          filters.type ? filters.type : this.orderByType, filters.status ? filters.status : this.filterByStatus);
        return filters.status;
      }
    },
    getSavedRentalIds() {
      let keys = '';
      if (this.account && this.account.id) {
        if (localStorage.getItem(`bookings_${this.account.id}_filtered_rental_ids`)) {
          keys = localStorage.getItem(`bookings_${this.account.id}_filtered_rental_ids`);
          keys = keys.split(',');
          keys.map((index) => {
            this.checkedRentals[index] = true;
          });
        }
      }
      return keys;
    },
    saveCheckedRentalIds(rentalIds) {
      if (this.account && this.account.id) {
        localStorage.removeItem(`bookings_${this.account.id}_filtered_rental_ids`);
        if (rentalIds.length > 0) {
          localStorage.setItem(`bookings_${this.account.id}_filtered_rental_ids`, rentalIds);
        }
      }
    },
  },
  computed: {
    listView() {
      const self = this;

      return self.bookings;
    },
    account() {
      return this.$store.state.account;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/bookings/index/index.js